<template>
  <v-color-picker
      v-model="internalValue"
      class="ma-2"
      show-swatches
      swatches-max-height="200px"
  ></v-color-picker>
</template>
<script>
export default {
  name:'ColorPalettePicker',
  props: {
    value:{type:String,default:'#a0a0a0'},
    text:String
  },
  data() {
    return {
      internalValue: this.value
    }
  },
  watch: {
    internalValue(newValue, oldValue) {
      this.$emit('input',newValue)
    }
  },

}
</script>
<style scoped>
.color-btn{
  color: white;
}
</style>